import React from 'react';
import PropTypes from 'prop-types';

const Avatar = ({ name, size = 50, textColor = '#fff' }) => {
  const firstLetter = name?.charAt(0).toUpperCase();
  const avatarStyle = {
    width: size,
    height: size,
    borderRadius: '50%',
    backgroundColor: 'var(--primary-color-gentlemenz)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: size * 0.4,
    color: textColor,
    fontWeight: 'bold',
  };

  return <div style={avatarStyle}>{firstLetter}</div>;
};

Avatar.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
  color: PropTypes.string,
  textColor: PropTypes.string,
};

export default Avatar;
